import { useMemo } from "react"
import { CollectionProps } from "@root/types/global"
import config from "@root/config.js"

const useCollectionSchema = (
  collection: CollectionProps | GatsbyTypes.SanityCollection | undefined,
  results: any[]
): string | undefined => {
  const collectionSchema = useMemo(() => {
    if (!collection) return undefined

    const itemListElement =
      results?.map((result, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: result.title,
        url: `https://${config.store.url}/${result.url}`,
      })) || []

    return JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: collection.title,
      description: collection.shopify?.seoDescription || collection.descriptionHtml,
      url: `https://${config.store.url}/collections/${collection.shopify.handle}`,
      image: collection.image,
      mainEntity: {
        "@type": "ItemList",
        itemListElement,
      },
    })
  }, [collection, results])

  return collectionSchema
}

export default useCollectionSchema
